import './Hero.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faArrowUpRightFromSquare, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import Separator from '../Separator';

export default function Hero() {
    return <div className='hero-container'>
    <div className='header-container'>
      <h1 className='name animate-reveal -reveal-to-right -delay-0.5'>Muhammad Junaid</h1>
      <div className='links-wrapper'>
        <div className='socials-wrapper'>
          <a className='social-item' href="mailto:mjunaid.s100@gmail.com" target='_blank' rel="noreferrer" title='email' aria-label='email'>
            <FontAwesomeIcon className="icon" icon={faEnvelope}/>
          </a>
          <a className='social-item' href="https://www.github.com/m-jojo-s" target='_blank' rel="noreferrer" title='github' aria-label='github'>
            <FontAwesomeIcon className="icon" icon={faGithub}/>
          </a>
          <a className='social-item' href="https://www.linkedin.com/in/mjojos" target='_blank' rel="noreferrer" title='linkedin' aria-label='linkedin'>
            <FontAwesomeIcon className="icon" icon={faLinkedin}/>
          </a>
        </div>
        <a className='link pill resume-link' target="_blank" rel="noreferrer" href="https://drive.google.com/file/d/1IbFi4yTf0o5FXwdgXpLmrxZR1YXxrYEi/view?usp=sharing">
          Resumé <FontAwesomeIcon className='icon' icon={faArrowUpRightFromSquare}/>
        </a>
      </div>
    </div>
    <h3 className='title animate-reveal -reveal-to-right -delay-1'>Full Stack Software Engineer</h3>
    <p className='summary text animate-reveal -reveal-to-right -delay-1.5'>I like to build detailed, user-focused applications.</p>
    <Separator/>
  </div>;
};